import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EvaluationQuestions from "./EvaluationQuestions";
import TwelveStatementEvaluationQuestions from "./TwelveStatementEvaluation";

import {
  updateEvaluationQuestion,
  updateEvaluation,
  completeEvaluation,
  addDriver,
  updatePeerResponse,
  evaluationState
} from "../../modules/evaluation/actions";
import Loader from "../../components/Loader";
import { MAX_PEERS_REACHED } from "../../modules/evaluation/constants";

class EvaluationQuestionsContainer extends React.Component {
  componentWillReceiveProps(nextProps) {
    window.scrollTo(0, 0);

    const { peer1, peer2, peer3 } = nextProps;
    if (peer1 && peer2 && peer3) {
      this.props.evaluationState(MAX_PEERS_REACHED);
    }
  }

  render() {
    const type = window.location.pathname.split("/")[1];

    const { id } = this.props.match.params;
    const { peer1, peer2, peer3 } = this.props;
    if (id && this.props.loading) {
      return <Loader invert />;
    }
    if (peer1 && peer2 && peer3) {
      return <div>Thanks</div>;
    }
    return type === "twelvesections" ? (
      <TwelveStatementEvaluationQuestions
        {...this.props}
        type={type}
        language={this.props.language}
        questions={this.props.questions}
        isPeerResponse={id}
        completeEvaluation={name => {
          if (id) {
            if (!peer1) {
              this.props.updatePeerResponse(
                id,
                "peer1",
                this.props.questions,
                name
              );
            } else if (!peer2) {
              this.props.updatePeerResponse(
                id,
                "peer2",
                this.props.questions,
                name
              );
            } else if (!peer3) {
              this.props.updatePeerResponse(
                id,
                "peer3",
                this.props.questions,
                name
              );
            }
          } else {
            this.props.addDriver(
              this.props.questions,
              this.props.userinfo,
              this.props.user,
              this.props.language,
              type
            );
          }
        }}
        updateEvaluationQuestion={this.props.updateEvaluationQuestion}
        updateEvaluation={this.props.updateEvaluation}
      />
    ) : (
      <EvaluationQuestions
        {...this.props}
        type={type}
        questions={this.props.questions}
        isPeerResponse={id}
        completeEvaluation={name => {
          if (id) {
            if (!peer1) {
              this.props.updatePeerResponse(
                id,
                "peer1",
                this.props.questions,
                name
              );
            } else if (!peer2) {
              this.props.updatePeerResponse(
                id,
                "peer2",
                this.props.questions,
                name
              );
            } else if (!peer3) {
              this.props.updatePeerResponse(
                id,
                "peer3",
                this.props.questions,
                name
              );
            }
          } else {
            type === "twentyfivesections"
              ? this.props.addDriver(
                  this.props.questions,
                  this.props.userinfo,
                  this.props.user,
                  this.props.language,
                  type
                )
              : this.props.completeEvaluation(
                  this.props.questions,
                  this.props.userinfo,
                  this.props.user,
                  this.props.language,
                  type
                );
          }
        }}
        updateEvaluationQuestion={this.props.updateEvaluationQuestion}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    scriptStep: state.evaluation.scriptStep,
    questions: state.evaluation.questions,
    submitting: state.evaluation.submitting,
    loading: state.results.loading,
    peer1: state.results.peer1,
    peer2: state.results.peer2,
    peer3: state.results.peer3,
    error: state.evaluation.error,
    highlight: state.results.highlight,
    result: state.results.result,
    ownerEmail: state.results.ownerEmail,
    owner: state.results.owner,
    userinfo: {
      fullName: state.evaluation.fullName,
      email: state.evaluation.email,
      age: state.evaluation.age,
      educationalLevel: state.evaluation.educationalLevel,
      leadershipExp: state.evaluation.leadershipExp,
      numberOfReferences: state.evaluation.numberOfReferences
    },
    language: state.preference.language,
    user: state.user.user
  };
}

const mapActionsToProps = {
  updatePeerResponse,
  updateEvaluationQuestion,
  updateEvaluation,
  completeEvaluation,
  addDriver,
  evaluationState
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(EvaluationQuestionsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/Evaluation/EvaluationQuestionsContainer.js